<template>
    <div>
        <el-select
            v-if="multiple"
            v-model="selectCompanys"
            filterable
            remote
            clearable
            reserve-keyword
            placeholder="请输入关键词"
            :multiple="true"
            :remote-method="queryCompanyList"
            :loading="loading" 
            @change="selectTrigger">
            <el-option
                v-for="item in companyList"
                :key="item.id"
                :label="item.companyName"
                :value="item.id">
            </el-option>
        </el-select>

        <el-select
            v-else
            v-model="selectCompany"
            filterable
            remote
            clearable
            reserve-keyword
            placeholder="请输入关键词"
            :remote-method="queryCompanyList"
            :loading="loading" 
            @change="selectTrigger">
            <el-option
                v-for="item in companyList"
                :key="item.id"
                :label="item.companyName"
                :value="item.id">
            </el-option>
        </el-select>
    </div>
</template>

<script>
    import { getCompanyList } from '@/data-model';

    export default {
        data () {
            return {
                loading: false,
                companyList: [],
                selectCompanys: [],
                mutilCompanys: '',
                selected: {
                    id: '',
                    companyName: ''
                },
                selectCompany: ''
            };
        },
        props: {
            field: {
                type: Object,
                required: true
            },
            formData: {
                type: Object,
                required: true
            },
            multiple: {
                type: Boolean,
                required: false
            }
        },
        created () {
            this.queryCompanyList('');
        },
        methods: {
            async queryCompanyList (companyName) {
                this.loading = true;
                let companyData = await getCompanyList(1, 500, companyName);
                this.companyList = companyData.data;
                this.loading = false;
            },
            selectTrigger (val) {
                if (this.multiple) {
                    if (this.formData) {
                        if (val) {
                            let names = [];
                            this.companyList.find((item) => {
                                val.find((it) => {
                                    if (item.id === it) {
                                        names.push(item.companyName);
                                    }
                                });
                            });
                            this.formData[this.field.formField] = val.join(',');
                            this.formData[this.field.formField + '-company'] = names.join(',');
                        } else {
                            this.companyList = [];
                            this.formData[this.field.formField] = '';
                            this.formData[this.field.formField + '-company'] = '';
                        }
                    }
                } else {
                    if (val) {
                        this.selected = this.companyList.find((item) => {
                            return item.id === val;
                        });
                    } else {
                        this.selected = {id: '', companyName: ''};
                    }
                    if (this.formData) {
                        this.formData[this.field.formField] = this.selected.id;
                        this.formData[this.field.formField + '-company'] = this.selected.companyName;
                    }
                }
                this.$emit('nodeClick', {id: this.selected.id, label: this.selected.companyName});
            }
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/CompanySelect/CompanySelect.vue